import { useEffect } from 'react';

interface IPostMessage {
  [key: string]: Function;
}

function parseEventData(data: string): Record<string, unknown> | null {
  try {
    return JSON.parse(data);
  } catch (error) {
    return null;
  }
}

const usePostMessage = (postMessage: IPostMessage) => {
  useEffect(() => {
    const messageEventListener = (event: MessageEvent) => {
      if (typeof event?.data !== 'string') return;

      if (!event.data.includes('|')) {
        const data = parseEventData(event.data);

        return data && postMessage[data.event as string]?.();
      }

      const [action, options] = event.data.split('|');
      const data = parseEventData(options);

      postMessage[action]?.(data);
    };

    window.addEventListener('message', messageEventListener, false);

    return () => {
      window.removeEventListener('message', messageEventListener, false);
    };
  }, []);
};

export default usePostMessage;
